/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Meta_TitleInputs */

const en_pc_online_meta_title = /** @type {(inputs: Pc_Online_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online: Free PDF Editor in Your Browser`)
};

const zh_pc_online_meta_title = /** @type {(inputs: Pc_Online_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版：浏览器中的免费 PDF 编辑器`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online: Free PDF Editor in Your Browser" |
*
* @param {Pc_Online_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_meta_title = /** @type {((inputs?: Pc_Online_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_meta_title(inputs)
	return zh_pc_online_meta_title(inputs)
});
export { pc_online_meta_title as "pc.online.meta_title" }